import {
  IndicatorRing,
  IndicatorRingProps
} from "../IndicatorRing/IndicatorRing";

export type OccupancyIndicatorProps = {
  occupiedSpaces: IndicatorRingProps["value"];
  totalSpaces: IndicatorRingProps["total"];
  variant?: IndicatorRingProps["variant"];
  displaySpacesCount?: boolean;
};

/** How full a space is: the number taken and an `IndicatorRing`. */
export const OccupancyIndicator = ({
  occupiedSpaces,
  totalSpaces,
  variant,
  displaySpacesCount = true
}: OccupancyIndicatorProps) => {
  return (
    <div className="flex items-center gap-2 text-content text-xs">
      {displaySpacesCount && occupiedSpaces}
      <IndicatorRing
        value={occupiedSpaces}
        total={totalSpaces}
        variant={variant}
      />
    </div>
  );
};
